<template>
  <el-dialog :visible.sync="visible" append-to-body :modal-append-to-body="false" top="10vh" lock-scroll class="cookie-dialog">
    <h5 class="mb-4">隱私權偏好設定</h5>
    <p class="mb-2">依據歐盟施行的個人資料保護法，我們致力於保護您的個人資料並提供您對個人資料的掌握。</p>
    <p>
      按一下「全部接受」，代表您與許我們置放 Cookie 來提升您在本網站的使用體驗、協助我們分析網站效能和使用狀況，以及讓我們投放相關聯的行銷內容。您可以在下方管理 Cookie
      設定。按一下「確認」即代表您同意目前採用的設定。
    </p>
    <div class="button-group">
      <BaseButton class="isStylePrimary isSizeGetcode isOutline" @click="goToPrivacy">查看隱私權政策</BaseButton>
      <BaseButton class="isStylePrimary isSizeGetcode" @click="acceptCookie">全部接受</BaseButton>
    </div>
    <h5 class="mb-4 mt-4">管理同意設定</h5>
    <div class="mb-2 d-flex justify-content-between">
      <p class="mb-0">必要的 Cookie</p>
      <p class="mb-0" style="color: #abcd03; cursor: pointer;" @click="acceptCookie">
        一律啟用
        <span><i class="el-icon-arrow-right el-icon--right"></i></span>
      </p>
    </div>
    <div style="background: #f5f5f5;">
      <p class="px-4 py-4">
        網站運行離不開這些必要的 Cookie 且你不能在系統中將其關閉。通常僅根據你所做出的操作(即服務請求)來設置這些 Cookie，如設置隱私偏好、登入或填充表格。您可以將您的瀏覽器設置為阻止或向您提示這些
        Cookie，但可能會導致某些網站功能無法工作。
      </p>
    </div>
    <BaseButton class="isStylePrimary isSizeGetcode" @click="acceptCookie">確認選擇</BaseButton>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    acceptCookie() {
      this.$emit('accept')
    },
    goToPrivacy() {
      this.$router.push('privacy')
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.cookie-dialog {
  .button-group {
    display: flex;
    justify-content: space-between;
  }
  @media(max-width: 768px) {
    .button-group {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }
  }
}
</style>
